/*
 * @Author: wangweixin
 * @Date: 2017-12-15 11:01:33
 * @Last Modified by: lujing
 * @Last Modified time: 2021-03-26 17:21:04
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import validate from './validators';
import classNames from 'classnames';

import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import Item from '../Item';

/**
 * 单个表单元素
 * 自带样式，规则验证等
 * 直接填充表单组件的内容即可
 */
export default class FormItem extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      !isEqual(nextProps.value, prevState.prevValue) &&
      nextProps.value !== undefined
    ) {
      return {
        ...prevState,
        value: nextProps.value,
        prevValue: nextProps.value
      };
    }
    return null;
  }
  state = {
    hasError: false,
    value: this.props.defaultValue
  };
  componentDidMount = () => {
    const { collector, field } = this.props;
    collector && collector.add(this);
    this.field = field;
  };
  componentWillUnmount = () => {
    const { collector } = this.props;
    collector && collector.remove(this);
  };
  /**
   * 重置值为defaultValue
   * @public
   */
  reset() {
    const { defaultValue } = this.props;
    this.setState({
      value: defaultValue,
      hasError: false
    });
  }
  /**
   * validate方法，会在collector.validate调用时被自动调用
   */
  validate = currentValue => {
    const { validators, data, collector, msg } = this.props;
    const { value } = this.state;

    const testValue = currentValue === undefined ? value : currentValue;
    if (isEmpty(validators)) return true;

    const failed = validators.some(rule => {
      if (Array.isArray(testValue)) {
        if (rule.required) {
          return !validate(testValue, rule);
        }
        if (rule.length) {
          return !validate(testValue, rule);
        }
        return testValue.some(v => {
          return !validate(v, rule, data);
        });
      }
      return !validate(testValue, rule, data);
    });

    if (failed) {
      this.setState({
        hasError: true
      });
      collector.setMessage(msg);
    } else {
      this.setState({
        hasError: false
      });
      collector.setMessage('');
    }
    return !failed;
  };
  handleInput = value => {
    const { onChange, trigger } = this.props;

    if (trigger === 'input') {
      let isOk = this.validate(value);

      this.setState({
        hasError: !isOk
      });
    }

    this.setState({
      value
    });
    onChange && onChange(value);
  };
  renderChildren() {
    const { children, showInfo, placeholder } = this.props;
    const { hasError, value } = this.state;

    if (showInfo) {
      return <div className="form-item-info">{value}</div>;
    }
    return children
      ? React.cloneElement(children, {
          onChange: this.handleInput,
          defaultValue: value,
          hasError,
          placeholder
        })
      : '';
  }
  render() {
    const {
      label,
      labelWidth = '100px',
      labelStyle,
      className,
      align,
      vAlign,
      style,
      hasColon,
      hasLabel,
      mini,
      bold
    } = this.props;
    const { hasError } = this.state;
    const lwidth =
      labelWidth.toString().indexOf('px') > 0 ? labelWidth : labelWidth + 'px';
    const classes = classNames(
      'form-group form-item-group',
      className,
      align,
      vAlign,
      {
        mini,
        bold
      }
    );
    const labelClasses = classNames('form-item-title-label', {
      required: this.isRequired,
      hasColon
    });
    return (
      <div className={classes} style={style}>
        <Item show={hasLabel}>
          <div
            className={labelClasses}
            style={{ flex: `0 0 ${lwidth}`, ...labelStyle }}
          >
            <span>{label}</span>
            {hasColon ? ' :' : ''}
          </div>
        </Item>

        <div className={`form-item-input ${hasError ? 'has-error' : ''}`}>
          {this.renderChildren()}
        </div>
      </div>
    );
  }
}
FormItem.displayName = 'FormItem';
FormItem.defaultProps = {
  trigger: 'input',
  hasColon: true,
  hasLabel: true,
  showInfo: false,
  align: 'left',
  vAlign: 'base',
  bold: false,
  mini: false
};
FormItem.propTypes = {
  /** 表单元素的标签 */
  label: PropTypes.any,
  /** 标签宽度 */
  labelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** 标签的特殊样式 */
  labelStyle: PropTypes.object,
  /** 是否包含标签 */
  hasLabel: PropTypes.bool,
  /** 默认值 */
  defaultValue: PropTypes.any,
  /** 验证规则 */
  validators: PropTypes.array,
  /** 是否有冒号 */
  hasColon: PropTypes.bool,
  /** 小版 */
  mini: PropTypes.bool,
  /** Label是否加粗 */
  bold: PropTypes.bool,
  /** 是否以信息形式展示 */
  showInfo: PropTypes.bool,
  /** 验证触发的时机 */
  trigger: PropTypes.oneOf(['input', 'blur']),
  /** 文字水平居中方式 */
  align: PropTypes.oneOf(['left', 'right']),
  /** 文字垂直居中方式 */
  vAlign: PropTypes.oneOf(['base', 'top', 'center', 'bottom']),
  /** Collector实例 */
  collector: PropTypes.any,
  /** value值，需要主动更新组件值的时候传入 */
  value: PropTypes.any
};
